import { render, staticRenderFns } from "./AdministrativeConcepts.vue?vue&type=template&id=7fac7a54&scoped=true&lang=pug&"
import script from "./AdministrativeConcepts.vue?vue&type=script&lang=js&"
export * from "./AdministrativeConcepts.vue?vue&type=script&lang=js&"
import style0 from "./AdministrativeConcepts.vue?vue&type=style&index=0&id=7fac7a54&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fac7a54",
  null
  
)

export default component.exports